export default __webpack_public_path__ + "static/media/ESSH16DRBE01_1920x1080.9573af4c.jpg";